import React from 'react';
import { Box } from '@mui/material';
import { sanitizeSummaryHtml } from '../../common/helpers';

/**
 * Sanitizes summary HTML for display and makes every link open in a new tab,
 * so following a link doesn't navigate away from the app inside Canvas. The
 * backend already sanitizes before saving; this repeats it in the browser so
 * anything else that reaches the database, still can't run code, show a fake
 * form or cover the app here.
 * @param {String} content The summary HTML
 * @returns {String} The sanitized HTML
 */
const toDisplayHtml = (content) => {
  const fragment = sanitizeSummaryHtml(content, { RETURN_DOM_FRAGMENT: true });
  fragment.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
  const container = document.createElement('div');
  container.append(fragment);
  return container.innerHTML;
};

function SummaryBody({ content }) {
  return (
    <Box className="mss__box summaryContent">
      <Box
        className="summaryBody"
        id="summaryDetails__box_body"
        dangerouslySetInnerHTML={{
          __html: toDisplayHtml(content),
        }}
      />
    </Box>
  );
}

export default SummaryBody;
